export default __webpack_public_path__ + "static/media/NetatmoOn.509263ec.svg";